import { ReactNode } from 'react'

import { FormattedMessage } from 'react-intl'
import { LuChevronLeft, LuX } from 'react-icons/lu'

import { Button } from '@/lib/core/components/Button'
import { ModalBase, ModalBaseProps } from '@/lib/core/components/Modal'
import {
  Close,
  Container,
  Content,
  Header,
  HeaderActions,
  HeaderContent,
  Subtitle,
  Title,
} from '@/lib/core/components/Modal/FeatureModal.styles'
import messages from '@/lib/core/components/Modal/Modal.messages'

import { FeatureTypes } from '@/lib/utils/features'

export type FeatureModalProps = ModalBaseProps & {
  goBackLabel?: string
  feature: FeatureTypes
  onClose?: (withSuccess?: boolean) => void
  onGoBack?: (() => void) | null
  subtitle?: string | ReactNode
  title: string | ReactNode
  titleIcon?: ReactNode
  containerClassName?: string
}

export const FeatureModal = ({
  children,
  goBackLabel,
  feature,
  onClose,
  onGoBack,
  isActive,
  subtitle,
  title,
  titleIcon = <></>,
  containerClassName,
}: FeatureModalProps) => {
  return (
    <ModalBase isActive={isActive} onEscape={() => onClose?.()}>
      <Container className={containerClassName}>
        <Header feature={feature}>
          <HeaderContent feature={feature}>
            <Title feature={feature}>
              {titleIcon}
              {title}
            </Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </HeaderContent>
          <HeaderActions feature={feature}>
            {onClose && (
              <Close data-testid="close-button" onClick={() => onClose()}>
                <LuX size="32" strokeWidth={1.5} />
              </Close>
            )}
            {onGoBack && (
              <Button
                type="button"
                $fitToContent
                lightVariant
                variant="ghost"
                size="large"
                onClick={onGoBack}
                leftIcon={<LuChevronLeft size="16" strokeWidth={1.5} />}
              >
                {goBackLabel || <FormattedMessage {...messages.back} />}
              </Button>
            )}
          </HeaderActions>
        </Header>
        <Content>{children}</Content>
      </Container>
    </ModalBase>
  )
}
